<template>
  <div class="revenue-summary-cards row mb-4">
    <div class="col-md-3">
      <div class="card border-0 shadow-sm bg-primary text-white p-3">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <div class="small opacity-75">Tổng doanh thu</div>
            <h3 class="mb-0">{{ summary.totalRevenue.toLocaleString() }}₫</h3>
          </div>
          <i class="fas fa-chart-line fa-2x opacity-25"></i>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <div class="card border-0 shadow-sm bg-success text-white p-3">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <div class="small opacity-75">Lợi nhuận gộp</div>
            <h3 class="mb-0">{{ summary.grossProfit.toLocaleString() }}₫</h3>
          </div>
          <i class="fas fa-hand-holding-usd fa-2x opacity-25"></i>
        </div>
      </div>
    </div>
    <div class="col-md-2">
      <div class="card border-0 shadow-sm bg-info text-white p-3">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <div class="small opacity-75">Số đơn hàng</div>
            <h3 class="mb-0">{{ summary.totalOrders }}</h3>
          </div>
          <i class="fas fa-shopping-cart fa-2x opacity-25"></i>
        </div>
      </div>
    </div>
    <div class="col-md-2">
      <div class="card border-0 shadow-sm bg-warning text-white p-3">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <div class="small opacity-75">Tiền trả hàng</div>
            <h3 class="mb-0">{{ summary.totalReturned.toLocaleString() }}₫</h3>
          </div>
          <i class="fas fa-undo fa-2x opacity-25"></i>
        </div>
      </div>
    </div>
    <div class="col-md-2">
      <div class="card border-0 shadow-sm bg-danger text-white p-3">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <div class="small opacity-75">Doanh thu thuần</div>
            <h3 class="mb-0">{{ summary.netRevenue.toLocaleString() }}₫</h3>
          </div>
          <i class="fas fa-wallet fa-2x opacity-25"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RevenueSummaryCards',
  props: {
    summary: {
      type: Object,
      default: () => ({
        totalRevenue: 0,
        totalCost: 0,
        totalReturned: 0,
        netRevenue: 0,
        grossProfit: 0,
        totalOrders: 0,
        totalReturnOrders: 0
      })
    }
  }
};
</script>

